import { useEffect } from "react";
import { HashRouter, Route, Routes, useLocation } from "react-router-dom";
import { Landing } from "./pages/Landing";
import { Portfolio } from "./pages/Portfolio";
import { trackPageView } from "./lib/analytics";

// HashRouter so a single static build serves both /#/ and /#/portfolio
// from GH Pages (no server-side rewrites required).
export function App() {
  return (
    <HashRouter>
      <AppRoutes />
    </HashRouter>
  );
}

// Per-route document titles — improves browser-tab UX and is the value
// search engines see when they re-crawl after JS execution.
const ROUTE_TITLES: Record<string, string> = {
  "/": "Mohan Krishna G R — AI/ML Research Engineer",
  "/portfolio": "Portfolio · Mohan Krishna G R — AI/ML Research Engineer",
};

function AppRoutes() {
  const location = useLocation();

  useEffect(() => {
    // Update <title> for the current route. Falls back to the landing title
    // for unknown paths (the catch-all renders Landing anyway).
    document.title = ROUTE_TITLES[location.pathname] ?? ROUTE_TITLES["/"];
    // Fire a GA4 `page_view` event on every route change (including initial
    // mount). HashRouter changes don't always trigger GA4's enhanced
    // measurement, so we send pageviews explicitly.
    trackPageView(location.pathname + location.search);
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}
